import { ArrowClockwise, House } from "react-bootstrap-icons";
import { isError, isErrorWithStatus } from "@/lib/type-guards";

interface Props {
  error: unknown;
}

export default function ErrorComponent(props: Props) {
  const message = isError(props.error) ? props.error.message : "Unknown error";
  const status = isErrorWithStatus(props.error) ? props.error.status : 500;

  return (
    <div className="d-flex justify-content-center h-100 flex-column gap-3 text-center align-items-center">
      <h1 className="display-1 mb-3">{status}</h1>
      <p className="text-muted">
        {status === 404 ? "Page not found" : "Oops! Something's not working."}
      </p>
      <div>
        <p className="text-muted">Here's the error message:</p>
        <p className="rounded-1 border border-danger bg-danger-subtle p-2 text-muted">
          {message}
        </p>
      </div>
      <div className="d-flex justify-content-center gap-2">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="btn btn-primary"
        >
          <ArrowClockwise /> Retry
        </button>

        <button
          type="button"
          onClick={() => window.location.assign("/")}
          className="btn btn-outline-primary"
        >
          <House /> Go home
        </button>
      </div>
    </div>
  );
}
